export const QueryKeys = {
  communities: {
    communitiesKey: 'communities',
    searchKey: 'search',
    byIdKey: 'byId',
    parentsKey: 'parents',
    childrenKey: 'children',
    membersKey: 'members',
    organizersKey: 'organizers',
  },
  admin: {
    allUsersKey: 'adminAllUsers',
    adminProfileKey: 'adminProfileKey',
    bulkKey: 'bulkKey',
  },
  versions: {
    versionsKey: 'versions',
  },
  profiles: {
    profileKey: 'profile',
    bulkProfilesKey: 'bulkProfiles',
    searchKey: 'search',
    blockedUsersKey: 'blockedUsers',
    tagsKey: 'tags',
    canonicalKey: 'canonical',
    byCommunityKey: 'byCommunity',
  },
  connections: {
    myConnectionsKey: 'myConnections',
    isConnectedKey: 'isConnected',
  },
  follows: {
    followingKey: 'following',
    followersKey: 'followers',
  },
  conversations: {
    conversationsKey: 'conversations',
    messagesKey: 'messages',
    unreadKey: 'unread',
    unreadCountKey: 'unreadCount',
    messagesPageSize: 20,
  },
  eventConversations: {
    eventMessagesKey: 'eventMessages',
    eventMessagesPageSize: 50,
  },
  events: {
    eventsKey: 'events',
    byOrgKey: 'byOrg',
    locationKey: 'location',
    byBulkKey: 'byBulkKey',
    temporalKey: 'temporal',
  },
  inbox: {
    inboxKey: 'inbox',
  },
  introductions: {
    myIntroductionsKey: 'myIntroductions',
    introductionsMadeByMeKey: 'introductionsMadeByMe',
  },
  people: {
    relationshipStatsKey: 'relationshipStats',
  },
  rooms: {
    roomsKey: 'rooms',
    byEventId: 'byEventId',
    sunriseExperienceKey: 'sunriseExperience',
    bulkRoomsKey: 'bulkRooms',
    attendeesKey: 'attendees',
  },
  tickets: {
    ticketsKey: 'tickets',
    byEventIdKey: 'byEventId',
    temporalKey: 'temporal',
    typeKey: 'ticketsType',
    countKey: 'count',
    receiptsKey: 'receipts',
    byUserKey: 'byUser',
    byReceiptIdKey: 'byReceiptId',
    calculateTotalKey: 'calculateTotal',
    checkoutStatusKey: 'checkoutStatus',
  },
  sessions: {
    sessionsKey: 'sessions',
    byEventIdKey: 'byEventId',
    byTagsKey: 'byTags',
    canonical: 'canonical',
    tagsKey: 'tags',
    votesKey: 'votes',
    voteCountKey: 'voteCount',
    attendeesKey: 'attendees',
    categoriesKey: 'categories',
    bulkSessionDataKey: 'bulkSessionData',
    bulkVotesKey: 'bulkVotes',
    userSessionVotesKey: 'userSessionVotes',
    tagCategoriesDetailsKey: 'tagCategoriesDetails',
    viewedKey: 'viewed',
    analyticsKey: 'analytics',
    locationsKey: 'locations',
    bySessionIdKey: 'bySessionId',
    favoritesKey: 'favorites',
    favoriteCountKey: 'favoriteCount',
    bulkFavoritesKey: 'bulkFavorites',
    userSessionFavoritesKey: 'userSessionFavorites',
    temporalKey: 'temporal',
    allUserFavoritesKey: 'allUserFavorites',
    byCommunityKey: 'byCommunity',
    communityFiltersKey: 'communityFilters',
    communityFilteredKey: 'communityFiltered',
    communitySpeakersKey: 'communitySpeakers',
  },
  tokens: {
    tokensKey: 'tokens',
  },
  extensions: {
    extensionsKey: 'extensions',
    commitments: 'commitments',
    price: 'price',
    currentExtensionRound: 'currentExtensionRound',
  },
  auctions: {
    auctionsKey: 'auctions',
    highestBid: 'highestBid',
    currentAuctionRound: 'currentAuctionRound',
  },
  grams: {
    gramsKey: 'grams',
    byUserIdKey: 'byUserId',
    fileUrlKey: 'fileUrl',
    socialSharesKey: 'socialShares',
    bySessionUserKey: 'bySessionUser',
    bySlugKey: 'bySlug',
    byUserEventKey: 'byUserEvent',
  },
  promos: {
    promosKey: 'promos',
    byEventKey: 'byEvent',
    groupPromosKey: 'groupPromos',
    bySlugKey: 'bySlug',
    byCommunityKey: 'byCommunity',
    myGroupPromosKey: 'myGroupPromos',
    bulkKey: 'bulk',
  },
  links: {
    linksKey: 'links',
    byCommunityKey: 'byCommunity',
    byIdKey: 'byId',
  },
  forms: {
    formsKey: 'forms',
    byCommunityKey: 'byCommunity',
    byIdKey: 'byId',
    bySlugKey: 'bySlug',
    fieldsKey: 'fields',
    submissionsKey: 'submissions',
    responsesKey: 'responses',
    templatesKey: 'templates',
    bulkKey: 'bulk',
    tagMappingsKey: 'tagMappings',
  },
  ledger: {
    ledgerKey: 'ledger',
    balanceKey: 'balance',
    payoutsKey: 'payouts',
    entriesKey: 'entries',
  },
};
